angular.module('rjmNg.directives').directive "timeFilterCohort", [
  "$timeout"
  "$document"
  (
    $timeout
    $document
  ) ->
    restrict: "E"
    templateUrl: "directive.timeFilterCohort.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      time: "="
      metrics: "="
      isDropdownOpen: "="
    controller: [
      "timeRangeEnums"
      "dateService"
      (
        timeRangeEnums
        dateService
      ) ->

        view = @

        TIME_INTERVAL_VALUES = timeRangeEnums.TIME_INTERVAL_VALUES
        TIME_RANGE_VALUES = timeRangeEnums.TIME_RANGE_VALUES
        DATE_DISPLAY_FORMAT = 'MMM D, YYYY'
        view.INTERVALS_TO_SHOW = [
          TIME_INTERVAL_VALUES.WEEK,
          TIME_INTERVAL_VALUES.MONTH,
          TIME_INTERVAL_VALUES.QUARTER,
          TIME_INTERVAL_VALUES.YEAR
        ]
        view.DATE_COLUMN_TYPE = "DATETIME"
        view.HIDDEN_MOVING_UNITS = ["Day", "Hour"]
        view.MOVING_TIME_RANGE_PRESETS = [
            [
              "LAST_WEEK"
              "LAST_MONTH"
              "LAST_QUARTER"
              "LAST_YEAR"
            ]
          ,
            [
              "THIS_WEEK"
              "THIS_MONTH"
              "THIS_QUARTER"
              "THIS_YEAR"
            ]
        ]

        view.timeRangeString = ""

        view.toggleDropdown = () ->
          view.isDropdownOpen = !view.isDropdownOpen

        view.updateTimeRangeString = () ->
          timeRangeName = dateService.getRangeString(view.time.timerange[1], DATE_DISPLAY_FORMAT, false)
          view.timeRangeString = "#{timeRangeName} over "

        view.closeDropdown = () ->
          view.isDropdownOpen = false

        view.apply = () ->
          # Time based Cohort
          if view.metrics[0].dimensions[0].datatype is view.DATE_COLUMN_TYPE
            view.time.range.end = view.localRangeDuration
          # Non-time based Cohort
          else
            tempTime = angular.copy(view.time)
            tempTime.interval = view.outputTimeInterval
            tempTime.range.end = view.localRangeDuration

            tempTime.timerange[0].start = angular.copy(view.timeRange.start)
            tempTime.timerange[0].end = angular.copy(view.timeRange.end)

            tempTime.timerange[1].start = angular.copy(view.timeRange.start)
            tempTime.timerange[1].end = angular.copy(view.timeRange.end)

            if dateService.isRangeMoving(view.timeRange)
              tempTime.timerange[0].end.value = 0
            else if tempTime.timerange[0].end isnt TIME_RANGE_VALUES.END
              tempTime.timerange[0].end.datetime = moment().format("YYYY-MM-DD")

            view.time = tempTime
            view.updateTimeRangeString()

          view.closeDropdown()

        view.cancel = () ->
          view.closeDropdown()

        view.initialization = () ->
          view.localRangeDuration = view.time.range.end

        view

    ]
    link: (scope, elem, attrs, view) ->
      # Click outside for closing
      $document.on("click", (event) ->
        $trigger = $(".time-filter")
        if $trigger isnt event.target and not $trigger.has(event.target).length
          $timeout(() -> view.closeDropdown())
      )

      scope.$watch('view.metrics[0].dimensions[0].datatype', (newType, oldType) ->
        if newType is view.DATE_COLUMN_TYPE
          view.timeBasedCohort = true
          view.timeRangeString = ""
        else
          view.timeBasedCohort = false
          view.updateTimeRangeString()
      )

      scope.$watch('view.time', (newTime, oldTime) ->
        if newTime.range?
          scope.$broadcast("initializeInterval")
          scope.$broadcast("initializeTimeRange")
          view.initialization()
      , true
      )

      scope.$watch('view.isDropdownOpen', (isDropdownOpen, old) ->
        if isDropdownOpen isnt old and isDropdownOpen is false
          scope.$broadcast("initializeInterval")
          scope.$broadcast("initializeTimeRange")
          view.initialization()
      )
]